import { IFarms } from "../../@types/API/IFarm";

export function getFarmsAsOptions(farms: IFarms) {
  return farms.map((farm) => ({
    label: `${farm.name}`,
    value: farm.id,
  }));
}
